import { supabase } from "@/integrations/supabase/client";
import { readEdgeError } from "@/lib/edgeError";

type InternalFn =
  | "internal-client-invite"
  | "internal-onboarding-checkout"
  | "internal-business-state"
  | "internal-operator-session"
  | "internal-invite-collaborator"
  | "internal-list-collaborators"
  | "internal-trial-accounts";

// Wraps operator-only Edge calls. Supabase attaches the current named employee
// session; each function verifies the user, internal allowlist, capability, and
// AAL2 server-side before using service-role authority.
export async function invokeInternal<T = unknown>(
  fn: InternalFn,
  body: Record<string, unknown>
) {
  const res = await supabase.functions.invoke<T>(fn, {
    body,
  });
  // Replace the opaque FunctionsHttpError with the real message from the
  // function's response body, so callers (and toasts) show the actual cause.
  if (res.error) {
    const message = await readEdgeError(res.error);
    return { data: null, error: new Error(message) } as typeof res;
  }
  return res;
}
